import { Select } from "antd"
import { useFormikContext } from "formik"

interface BillableSelectFieldComponentProps extends React.ComponentProps<typeof Select> {
  name: string
}

const BillableSelectField = (props: BillableSelectFieldComponentProps) => {
  const {
    name,
    ...selectProps
  } = props

  const formik = useFormikContext()
  const field = formik.getFieldProps(name)

  // translate boolean to selectValueString
  const selectValue = field.value === undefined ? undefined : (!!field.value ? 'billable' : 'non-billable')

  // translate selectValueString to boolean in formik
  const onChange = (val: string) => {
    if (val == 'all') {
      // undefined for all
      formik.setFieldValue(field.name, undefined)
    } else {
      // true / false
      formik.setFieldValue(field.name, val == 'billable')
    }
  }

  return (
    <Select 
      {...selectProps} 

      style={{
        width: '180px',
        ...selectProps.style,
      }}

      value={selectValue}
      onChange={onChange}
      placeholder="Billable & Non-billable"
    >
      <Select.Option value="all">Billable & Non-billable</Select.Option>
      <Select.Option value="billable">Only billable</Select.Option>
      <Select.Option value="non-billable">Only non-billable</Select.Option>
    </Select>
  )
}

export default BillableSelectField